import { db } from './firebase.js';
import { collection, addDoc } from 'firebase/firestore';


// Function to add data to Firestore
// export const addDataToFirestore = async (data) => {
//   try {
//     const collectionRef = collection(db, 'projects'); // Replace 'yourCollectionName' with your Firestore collection name

//     for (const item of data) {
//       await addDoc(collectionRef, item);
//       console.log('Document written with ID: ', item);
//     }
//   } catch (e) {
//     console.error('Error adding document: ', e);
//   }
// };

export const addDataToFirestore = async (data, collectionName) => {
  try {
    const collectionRef = collection(db, collectionName); 

      await addDoc(collectionRef, data)
      console.log('Document written with ID: ', data);
  } catch (e) {
    console.error('Error adding document: ', e);
  }
};
